import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ImportarPessoas } from '../importar-pessoas/importar-pessoas';
import { ImportarPessoasHistorico } from '../importar-pessoas-historico/importar-pessoas-historico';

@Component({
  selector: 'app-importar-pessoas-controller',
  imports: [CommonModule, ImportarPessoas, ImportarPessoasHistorico],
  templateUrl: './importar-pessoas-controller.html',
  styleUrl: './importar-pessoas-controller.scss',
})
export class ImportarPessoasController {
  telaExibida: number = 1; // 1 para importação, 2 para histórico
}
